import { render, staticRenderFns } from "./ActiveShelf.vue?vue&type=template&id=a1711b6c&scoped=true"
import script from "./ActiveShelf.vue?vue&type=script&lang=js"
export * from "./ActiveShelf.vue?vue&type=script&lang=js"
import style0 from "./ActiveShelf.vue?vue&type=style&index=0&id=a1711b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1711b6c",
  null
  
)

export default component.exports